module.exports = __webpack_public_path__ + "img/future_dates.d41d8cd9.svg";